import { APP_INITIALIZER } from '@angular/core';
import { ConfigLoaderService } from '@core/config-angular';

import { JourneyAnalyticsLoader } from './journey-analytics-loader.service';

function journeyAnalyticsFactory(
  configLoader: ConfigLoaderService,
  analyticsLoader: JourneyAnalyticsLoader
): () => Promise<void> {
  return async () => {
    const config = await configLoader.getConfigAsync();
    await analyticsLoader.load(config);
  };
}

/**
 * Provider that initializes the Journey Analytics instances.
 */
export const provideJourneyAnalytics = () => ({
  provide: APP_INITIALIZER,
  useFactory: journeyAnalyticsFactory,
  deps: [ConfigLoaderService, JourneyAnalyticsLoader],
  multi: true,
});
